import MasterTable from './MasterTable'

/* ข้อมูลหลัก → บริษัท · backend: src/routes/adminCompanies.js
   ตารางนี้ต่างจากแผนก/สาขาตรงที่ **ไม่กรองตามบริษัทของ session** เพราะมันคือ
   ทะเบียนบริษัทเอง กรองแล้วเหลือแถวเดียวก็ไม่เหลือประโยชน์ */

type Company = {
  CompanyNo: number
  CompanyCode: string
  CompanyName: string | null
  CompanyBuID: string | null
  inactive: boolean
  staffCount: number
}

export default function Companies() {
  return (
    <MasterTable<Company>
      title="บริษัท"
      unit="บริษัท"
      addLabel="เพิ่มบริษัท"
      base="/api/admin/companies"
      keyOf={(r) => r.CompanyNo}
      labelOf={(r) => `${r.CompanyCode} ${r.CompanyName ?? ''}`}
      isInactive={(r) => r.inactive}
      cols={[
        { label: 'รหัส', cell: (r) => r.CompanyCode, sortKey: 'code' },
        { label: 'ชื่อบริษัท', cell: (r) => r.CompanyName ?? '-', sortKey: 'name' },
        { label: 'พนักงาน', cell: (r) => r.staffCount, num: true, sortKey: 'staff' },
      ]}
      fields={[
        { name: 'companyCode', label: 'รหัสบริษัท', maxLength: 20, required: true },
        { name: 'companyName', label: 'ชื่อบริษัท', maxLength: 100 },
        { name: 'companyBuID', label: 'BU', maxLength: 100 },
      ]}
      toDraft={(r) => ({
        companyCode: r.CompanyCode,
        companyName: r.CompanyName ?? '',
        companyBuID: r.CompanyBuID ?? '',
      })}
    />
  )
}
